export const isValidStripePublishableKey = (key?: string | null): boolean => {
  if (!key) return false;
  if (key.includes('...')) return false;
  return key.startsWith('pk_test_') || key.startsWith('pk_live_');
};

export const getEnvStripePublishableKey = (): string =>
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
